import { ReactNode } from 'react';

interface SectionWrapperProps {
  id: string;
  children: ReactNode;
  className?: string;
}

export function SectionWrapper({ id, children, className = '' }: SectionWrapperProps) {
  return (
    <section 
      id={id} 
      className={`relative min-h-screen ${className}`}
    >
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 to-slate-900/80 z-10" />
      </div>
      <div className="relative z-20">
        {children}
      </div>
    </section>
  );
} 